(function() {
  'use strict';
  
  let lastOpened = null;
  let isProcessing = false;
  
  document.addEventListener('click', function(e) {
    if (isProcessing) return;
    
    const accordion = e.target.closest([
      '.collapsible-tabs__tab',
      'summary',
      '[data-cc-animate-click]',
      '.accordion-item',
      '.product-detail-accordion > div'
    ].join(', '));
    
    if (!accordion) return;
    
    isProcessing = true;
    
    setTimeout(() => {
      const isOpen = 
        accordion.classList.contains('is-open') ||
        accordion.classList.contains('active') ||
        accordion.parentElement?.classList.contains('is-open') ||
        (accordion.tagName === 'SUMMARY' && accordion.parentElement?.hasAttribute('open'));
      
      if (isOpen) {
        // Close previous
        if (lastOpened && lastOpened !== accordion) {
          lastOpened.click();
        }
        
        lastOpened = accordion;
        
        // Scroll to the opening accordion
        setTimeout(() => {
          const container = accordion.closest('.product-detail-accordion, .product-collapsible-tab, details') || accordion;
          const offset = 100; // Offset from top (adjust as needed)
          
          const elementTop = container.getBoundingClientRect().top + window.pageYOffset;
          
          window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth'
          });
        }, 100);
        
      } else if (accordion === lastOpened) {
        lastOpened = null;
      }
      
      setTimeout(() => {
        isProcessing = false;
      }, 500);
      
    }, 100);
  });
  
  console.log('✅ Accordion auto-closer ready');
})();